"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThumbnailDefault = void 0;
const helpers_1 = require("../helpers");
const getThumbnailDefault = (businessUnit) => {
    const shortBrandName = helpers_1.businessUnitToEnv[businessUnit].toLowerCase();
    return `https://meucatalogodigitalresources.grupoboticario.digital/assets/images/avatar/thumb-${shortBrandName}.png`;
};
exports.getThumbnailDefault = getThumbnailDefault;
